export const apiBaseUrl = import.meta.env.VITE_API_URL || '';
export const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
export const mapProvider = import.meta.env.VITE_MAP_PROVIDER || '';
export const osmNominatimUrl = import.meta.env.VITE_OSM_NOMINATIM_URL || '';
export const osmPhotonUrl = import.meta.env.VITE_OSM_PHOTON_URL || '';
export const osmOsrmUrl = import.meta.env.VITE_OSM_OSRM_URL || '';
export const mapboxApiKey = import.meta.env.VITE_MAPBOX_API_KEY || '';
export const defaultPageSize = import.meta.env.VITE_DEFAULT_PAGE_SIZE;
export const isDevelopment = import.meta.env.VITE_IS_DEV === 'true';
export const wialonApi = import.meta.env.VITE_WIALON_API;
export const mode = import.meta.env.MODE;
